import { AssignmentEntity, InstructorLeaderboardQueryEntity, RoInstructorAssignmentsPerWeekEntity } from "../../../../meta-data/app-meta-data.service";

export interface InstructorStatEntity extends InstructorLeaderboardQueryEntity {
    ACSTestsTakenText: string;
    ActiveStudents: number,
    AverageProgress: number,
    CompletedStudents: number,
    ACSAverageFirstTimePassRate: number,
    ACSTestsUploaded?: number
    ACSAverageTestScore?: number;
    
    // Populated during post-processing
    Weight?: number;
    Rank?: number;
    AverageAssignmentsPerWeek?: number;
    CompletionRate?: number;
}

export enum InstructorStatAggregateFields {
    ActiveStudents= 'ActiveStudents',
    AverageProgress= 'AverageProgress',
    CompletedStudents = 'CompletedStudents',
    ACSAverageFirstTimePassRate = 'ACSAverageFirstTimePassRate',
    ACSAverageTestScore = 'ACSAverageTestScore',
    ACSTestsUploaded = 'ACSTestsUploaded',
}

export interface InstructorAssignmentStatEntity extends RoInstructorAssignmentsPerWeekEntity {
    AverageAssignmentsPerWeek: number,
}

export enum InstructorAssignmentStatAggregateFields {
    AverageAssignmentsPerWeek= 'AverageAssignmentsPerWeek',
}